import { Copy } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

interface ShareViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  viewName: string;
  shareUrl: string;
}

export const ShareViewDialog = ({
  open,
  onOpenChange,
  viewName,
  shareUrl,
}: ShareViewDialogProps) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied');
    } catch {
      toast.error('Could not copy the link');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Share “{viewName}”</DialogTitle>
          <DialogDescription>
            Anyone who opens this link lands on this page with these filters applied. It&apos;s a
            copy — whatever they change afterwards doesn&apos;t affect your view.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2">
          <Input
            readOnly
            value={shareUrl}
            aria-label="Share link"
            onFocus={e => e.currentTarget.select()}
          />
          <Button onClick={handleCopy} className="shrink-0">
            <Copy className="mr-1.5 h-4 w-4" />
            Copy link
          </Button>
        </div>
        <p className="text-sm text-muted-foreground">
          They&apos;ll need to save it to keep it — otherwise it&apos;s gone when they navigate
          away.
        </p>
      </DialogContent>
    </Dialog>
  );
};
